import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyB4NsJ4fu9X80Haz5yZMEdcxE-FQKrvdnY",
  authDomain:"n-ce38f.firebaseapp.com",
  projectId: "n-ce38f",
  storageBucket: "n-ce38f.firebasestorage.app",
  messagingSenderId:"731321060784",
  appId: "1:731321060784:web:30cc4dc1989eeae1a1da75"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export {auth , db}